<template>
  <rmb class="rmb-svg" :html="svg" v-if="svg"></rmb>
  <span v-else>¥</span>
</template>
<script>
import Vue from 'vue';
export default {
  name: 'Currency',
  props: {
    /**
     * 类型
     * 1-字符;2-普通价格图标;3-划线价格图标
     */
    type: {
      default: 2,
    },
  },
  computed: {
    svg() {
      return this.$store.state.svg;
    },
  },
  components: {
    rmb: {
      props: {
        html: String,
      },
      render(h) {
        const com = Vue.extend({
          template: this.html,
        });
        return h(com, {});
      },
    },
  },
};
</script>
<style lang="scss">
.rmb-svg,
.rmb-svg g,
.rmb-svg path {
  fill: currentColor !important;
  height: 0.9em;
  width: auto;
  width: 0.7em;
}
</style>
